/* Global Blockly */ 
import { dropdownIcon } from "../../../../v1/blocks/WidgetValues/Dropdown";

function defineBlock (context) {
    return {
        init: function () {
            var valueOrTextDropdown = new Blockly.FieldDropdown([["text","TEXT"],["unique ID","VALUE"]]);
            var equalNotEqual = new Blockly.FieldDropdown([["=", "EQUAL"], ["≠", "NOTEQUAL"]]);
            var widgetDropdown = new Blockly.FieldWidgetsDropdown(context, "dropdown", undefined, "- select -");
            this.appendValueInput("VALUE")
                .appendField("remove from ")
                .appendField(new Blockly.FieldImage(dropdownIcon, 30, 30, "dropdown icon", null), "dropdownIcon")
                .appendField(widgetDropdown, "ID")
                .appendField("all options where")
                .appendField(valueOrTextDropdown, "VORT")
                .appendField(equalNotEqual, "OPERATOR");

            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);

            this.setTooltip(() => {
                var valortext = this.getFieldValue("VORT");
                var comparison = this.getFieldValue("OPERATOR");
                return "Remove all options from a dropdown where the " + 
                    (valortext === "TEXT" ? "text " : "unique ID ") + 
                    (comparison === "EQUAL" ? "equals" : "does not equal") + " the specified string";
            })
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#dropdowns");
        },
    }
}

function defineGenerators () {
    return {
        "JavaScript": function (block) {
            const id = block.getFieldValue("ID");
            const vort = block.getFieldValue("VORT") == "TEXT" ? "text" : "uniqueID";
            const operator = block.getFieldValue("OPERATOR");
            const value =  Blockly.JavaScript.valueToCode(block, "VALUE", Blockly.JavaScript.ORDER_NONE);

            return `Snap.widgets.dropdown.deleteOption("${id}", "${vort}", "${operator}", ${value});\n`;
        }
    }
}

const RemoveDropdownOption = function (props) {
    const name = 'snap_remove_dropdown_option';
    RemoveDropdownOption.blockName = name; 

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }
    
    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget && (props.widget.id !== undefined)
                ? <field name="ID">{props.widget.id}</field>
                : null
            }
            <value name="VALUE">
                <shadow type="text"/>
            </value>
        </block>
    );

}

export default RemoveDropdownOption; 